export const apiPath = process.env.REACT_APP_API_URL

export default apiPath



// WEBPACK FOOTER //
// ./src/modules/const.js